import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const fetchTyreData = createAsyncThunk(
    'maintenance/fetchTyreData',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getTyreData(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch maintenance data');
        }
    }
);

const initialState = {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
};

const tyreSlice = createSlice({
    name: 'tyre',
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTyreData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTyreData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload?.data?.results || [];
                state.meta = action.payload?.data?.meta || {};
                state.error = null;
            })
            .addCase(fetchTyreData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.data = [];
            });
    },
});

export const { setCurrentPage, clearError } = tyreSlice.actions;

export default tyreSlice.reducer;
